import { Injectable } from '@angular/core';
import * as Rx from 'rxjs';

@Injectable()
export class WebSocketServiceFake {
  fromServerStream$ = new Rx.BehaviorSubject<number>(0);

  setChannels(channels: ReadonlyArray<number>) {
    // not implemented
  }
}
